import React from 'react';
import { Link } from 'react-router-dom';

export interface Props extends React.AriaAttributes {
  to?: string;
  href?: string;
  type?: 'button' | 'submit' | 'reset';
  target?: string;
  rel?: string;
  children: React.ReactNode;
  onClick?: any;
  theme?: string;
}

export const getRel = (target = '', rel = '') => {
  if (target === '_blank') {
    return `${rel || ''} noopener noreferrer`;
  }

  return rel;
};

const Action: React.FC<Props> = ({
  href,
  type,
  target,
  rel,
  children,
  onClick,
  theme,
  to,
  ...rest
}: Props) => {
  let Component: any;

  if (href || to) {
    Component = href ? 'a' : Link;
  } else {
    Component = 'button';
  }

  const actionRel = getRel(target, rel);
  const actionType = Component === 'button' ? type || 'button' : undefined;

  return (
    <Component
      target={target}
      href={href}
      to={to}
      rel={actionRel}
      type={actionType}
      onClick={onClick}
      className={theme}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default Action;
